exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\ndiv.plotly-notifier{visibility:hidden\n}\n.justify-items-center .plot-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n", "", {"version":3,"sources":["/app/frontend/src/components/AppPlotly.vue"],"names":[],"mappings":";AAmFA,oBACE,iBAAkB;CACnB;AAAA,sCAEC,oBAAA,oBAAA,aACA,wBAAA,qBAAA,sBAAuB;CACxB","file":"AppPlotly.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\ndiv.plotly-notifier {\n  visibility: hidden;\n}\n.justify-items-center .plot-container {\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b8af82f","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AppPlotly.vue
// module id = k+2q
// module chunks = 11